export default {
    getIssueCategories: {
        url: "/api/v1/issue-tracker/issue-category",
        method: "get"
    },
    createIssueCategory: {
        url: "/api/v1/issue-tracker/issue-category",
        method: "post"
    },
    updateIssueCategory: {
        url: "/api/v1/issue-tracker/issue-category/{issueCategoryId}",
        method: "put"
    },
    patchIssueCategory: {
        url: "/api/v1/issue-tracker/issue-category/{issueCategoryId}",
        method: "patch"
    },
    getIssuePriorities: {
        url: "/api/v1/issue-tracker/issue-priority",
        method: "get"
    },
    createIssuePriority: {
        url: "/api/v1/issue-tracker/issue-priority",
        method: "post"
    },
    updateIssuePriority: {
        url: "/api/v1/issue-tracker/issue-priority",
        method: "put"
    },
    patchIssuePriority: {
        url: "/api/v1/issue-tracker/issue-priority/{issuePriorityId}",
        method: "patch"
    },
    getEducatorIssueList: {
        url: "/api/v1/issue-tracker/issue-list",
        method: "post"
    },
    createIssue: {
        url: "/api/v1/issue-tracker/issue",
        method: "post"
    },
    getIssueDetail: {
        url: "/api/v1/issue-tracker/issue/{issueId}",
        method: "get"
    },
    updateIssue: {
        url: "/api/v1/issue-tracker/issue/{issueId}",
        method: "put"
    },
    addIssueComment: {
        url: "/api/v1/issue-tracker/issue-comment",
        method: "post"
    },
    getIssueComments: {
        url: "/api/v1/issue-tracker/issue-comment/{issueId}",
        method: "get"
    },
    getIssueBySchool: {
        url: "/api/v1/issue-tracker/issue-by-school",
        method: "get"
    },
    getIssueByCategory: {
        url: "/api/v1/issue-tracker/issue-by-category",
        method: "get"
    },
    getIssueByPriority: {
        url: "/api/v1/issue-tracker/issue-by-priority",
        method: "get"
    },
    getIssueByDays: {
        url: "/api/v1/issue-tracker/issue-by-days",
        method: "get"
    },
    getIssueKpis: {
        url: "/api/v1/issue-tracker/issue-kpis",
        method: "get"
    },
    exportIssues: {
        url: "/api/v1/issue-tracker/issue-export",
        method: "post"
    }
};

